import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Badge from 'components/Badge';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { getLiveMetaData, isMvpdSubscription } from 'helpers/ContentHelper';
import ProgressBar from '../ProgressBar';
import Style from './BannerDetail.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    showData: true,
  },
  [SITE_PLATFORM_WEB]: {
    showData: true,
  },
  [SITE_PLATFORM_TABLET]: {
    showData: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    showData: false,
  },
};

const BannerDetail = props => {
  const { breakpoint, isAuthenticated, onTvProviderClick, video } = props;
  const { auth_signInHeader: signInWithProviderText } = window.Language;
  const fncLogo = _.get(window, 'ExternalConfig.auth.perks.0.icon');
  const { description, durationInSeconds, name, seriesName, startDate } = video;
  const metadata = getLiveMetaData({ startDate, durationInSeconds });

  const { showData } = BREAKPOINTS[breakpoint];
  const renderBadge = showData && isAuthenticated;
  const renderDescription = showData;
  const renderMetadata = showData && isAuthenticated;
  const renderButton = !isAuthenticated && !isMvpdSubscription();

  return (
    <div className={Style.detailContainer}>
      <div className={Style.innerContainer}>
        {renderBadge && <Badge badge="live" theme={Style} />}
        <div className={Style.titleContainer}>
          <img className={Style.logo} src={fncLogo} alt="FNC Logo" />
          <div className={Style.title}>{seriesName || name}</div>
        </div>
        {renderDescription && <div className={Style.description}>{description}</div>}
        {renderMetadata && (
          <>
            <ProgressBar theme={Style} video={video} />
            <div className={Style.meta}>{metadata}</div>
          </>
        )}
        {renderButton && (
          <div className={Style.button} onClick={onTvProviderClick}>
            {signInWithProviderText}
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerDetail;

BannerDetail.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  onTvProviderClick: PropTypes.func.isRequired,
  video: PropTypes.shape({}).isRequired,
};
